import { useQuery } from "@tanstack/react-query"
import { supabase } from "../supabaseClient"

export function useOrganizationAccountCount(
  organizationId,
  { enabled = true } = {},
) {
  return useQuery({
    queryKey: ["organization-account-count", organizationId],
    queryFn: async () => {
      if (!organizationId) return 0
      const { count, error } = await supabase
        .from("accounts")
        .select("id", { count: "exact", head: true })
        .eq("organization_id", organizationId)
      if (error) {
        console.error("Failed to load organization account count", error)
        throw error
      }
      return count ?? 0
    },
    enabled: enabled && !!organizationId,
  })
}
